module.exports = __webpack_public_path__ + "static/media/speed-bg.d92ab1f1.png";